import React from 'react';
import styled from 'styled-components';
import { isProUser } from '__utils/common-utils';
import { COLOR } from 'constants/colors';
import { CommonStyledComponentProps, FlashTypes } from '__utils/type';
import { useMediaQuery } from 'react-responsive';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import FlashSelector from './flash.selector';
import useFlashToggler from 'hooks/use-flash-toggler';

const FlashContainerDiv = styled.div<CommonStyledComponentProps>`
    color: ${COLOR.WHITE};
    position: fixed;
    top: ${isProUser() ? '82px' : '60px'};
    width: ${(props: CommonStyledComponentProps) => props.isMobile ? `80vw` : `80vh`};
    padding: 10px;
    /* display: none; */
    z-index: 900000;
    border-radius: 0px;
    text-align: center;
    justify-content: center;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    
    p {
        flex: 1;
    }
    .close {
        position: relative;
        top: 4px;
        float: left;
        font-weight: bold;
        line-height: 1;
        filter: alpha(opacity=20);
        cursor: pointer;
    }
    &.success{
        display: flex;
        background-color: ${COLOR.FLASHSUCCESS_BG};
        color: ${COLOR.FLASHSUCCESS};            
    }
    &.error{
        display: flex;
        background-color: ${COLOR.FLASHERROR_BG};
        color: ${COLOR.FLASHERROR};            
    }
`;

const Flash: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flashState = propsToJS(useSelector(FlashSelector));
    const flash = useFlashToggler();

    return <>
       { flashState.flashState.message && <FlashContainerDiv /* id="flashDiv" */ isMobile={ isMobile } className = {`${flashState.flashState.type}`}>
            <span className="close" onClick={ flash.hide }><strong>{flashState.flashState.type === FlashTypes.SUCCESS ?  '✔ ' : '✕ '}</strong></span>
            <p>{flashState.flashState.message}</p>
        </FlashContainerDiv>}
    </>;
}

export default Flash;